import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StoreService } from '../store.service';


export class ApiBaseService {

  accessToken: string = '';

  storeService: StoreService;
  httpClient: HttpClient;

  constructor(
  ) { 
    this.storeService = inject(StoreService);
    this.httpClient = inject(HttpClient);

    this.storeService.getAuthToken().subscribe(
      (data : any) => { this.accessToken = data ? data['accessToken'] : null }
    )
  }

  GET(url: string, params?: HttpParams) : Observable<any>
  {
    let headers : { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if(this.accessToken)
    {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.get<any>(url, {
      headers,
      params
    });
  }

  POST(url: string, data: any, params?: HttpParams) : Observable<any>
  {
    let headers : { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if(this.accessToken)
    {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }    

    return this.httpClient.post<any>(url, data, {
      headers,
      params
    });
  }  
  PUT(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };
    
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }
  
    return this.httpClient.put<any>(url, data, {
      headers,
      params
    });
  }

  POSTUrlEncoded(url: string, urlSearchParams: URLSearchParams, params?: HttpParams) : Observable<any>
  {
    let headers : { [key: string]: string } = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    if(this.accessToken)
    {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }
    
    return this.httpClient.post<any>(url, urlSearchParams, {
      headers,
      params
    });
  }    

  DELETE(url: string, params?: HttpParams) : Observable<any>
  {
    let headers : { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if(this.accessToken)
    {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.delete<any>(url, {
      headers,
      params
    });
  }  

  getUrl(path: string) : string {
    return `${environment.apiBaseUrl}${path}`
  }
}
